export const hasPermission = (permissionList, permissionRequired) => {
  return permissionList.includes(permissionRequired);
};

export const hasBlock = (blockList, blockRequired) => {
  return blockList.includes(blockRequired);
};